<div class="signBlock">
    <div class="formBlock" style="overflow-y: auto; -ms-overflow-style: -ms-autohiding-scrollbar;">
        <div id="id_alert"></div>
        
        <div class="signlogo">
            <a routerLink="/"><img src="/assets/site/images/lauditor_logo_blue_font.png" alt="DigiCoffer" /></a>
			<!-- <p class="text-left" style="color:gray;">Lauditor</p> -->
        </div>

        <!-- ============================================
             PASSWORD REGISTRATION FORM - COMMENTED OUT
             ============================================
        <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
            <div class="signTitle">Registration Request</div>
            <div class="signForm-row">
                <input class="form-control" id='id_firmname' type="text" placeholder="Firm Name"
                    formControlName="fullname" />
                <p class='text-danger' id='error-fullname'></p>
            </div>
            <div class="signForm-row">
                <input class="form-control" type="email" id="id_email" placeholder="Email" formControlName="email" />
                <p class='text-danger' id='error-email'></p>
            </div>
            <div class="signForm-row">
                <input class="form-control" type="text" id="id_contact_person" placeholder="Contact Person"
                    formControlName="contact_person" />
                <p class='text-danger' id='error-contact_person'></p>
            </div>
            <div class="signForm-row">
                <input class="form-control" type="text" id="id_contact_phone" placeholder="Contact Phone"
                    formControlName="contact_phone" />
                <p class='text-danger' id='error-contact_phone'></p>
            </div>
            <div class="signForm-row signUpT">
                Read our <a href="https://digicoffer.com/digicoffer_terms.pdf">Terms</a> & <a href="https://digicoffer.com/privacy.html">Privacy Policy</a>
            </div>
            <div class="signForm-row">
                <button class="signBtn">Submit</button>
            </div>
        </form>
        -->

        <!-- OTP Registration Form - NOW THE PRIMARY REGISTRATION METHOD -->
        <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
            <div class="signTitle">Registration Request</div>
            
            <!-- Firm Name -->
            <div class="signForm-row">
                <input class="form-control" 
                       id='id_firmname' 
                       type="text" 
                       placeholder="Firm Name"
                       formControlName="fullname"
                       [readonly]="otpSent" />
                <div *ngIf="otpSubmitted && otpF['fullname'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF['fullname'].errors.required">Firm Name is required</div>
                </div>
                <p class='text-danger' id='error-fullname'></p>
            </div>
            
            <!-- Email or Mobile -->
            <div class="signForm-row">
                <input class="form-control" 
                       type="text" 
                       id="id_identifier" 
                       placeholder="Email or Mobile" 
                       formControlName="identifier"
                       [readonly]="otpSent" />
                <div *ngIf="otpSubmitted && otpF['identifier'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF.identifier.errors.required">
                        Email or Mobile is required
                    </div>
                    <div class="errorStyle" *ngIf="otpF.identifier.errors.invalidIdentifier">
                        Enter a valid email or 10-digit mobile number
                    </div>
                </div>
                <p class='text-danger' id='error-identifier'></p>
            </div>
            
            <!-- Contact Person -->
            <div class="signForm-row">
                <input class="form-control" 
                       type="text" 
                       id="id_contact_person" 
                       placeholder="Contact Person"
                       formControlName="contact_person"
                       [readonly]="otpSent" />
                <div *ngIf="otpSubmitted && otpF['contact_person'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF['contact_person'].errors.required">Contact Person is required</div>
                </div>
                <p class='text-danger' id='error-contact_person'></p>
            </div>

            <!-- OTP Input (visible after OTP is sent) -->
            <div class="signForm-row" *ngIf="otpSent">
                <label class="otp-label" style="font-weight: 600; margin-bottom: 10px; display: block;">Enter OTP</label>
                <div class="otp-inputs-container" style="display: flex; justify-content: space-between; gap: 10px; margin-bottom: 10px;">
                    <input 
                        #otp1
                        type="text" 
                        maxlength="1" 
                        class="otp-box"
                        style="width: 50px; height: 50px; text-align: center; font-size: 20px; font-weight: 600; border: 2px solid #CECECE; border-radius: 8px; background: #FFFFFF;"
                        (keyup)="onOtpKeyUp($event, 1, otp2)"
                        (paste)="onOtpPaste($event)"
                        [(ngModel)]="otpDigits[0]"
                        [ngModelOptions]="{standalone: true}"/>
                    <input 
                        #otp2
                        type="text" 
                        maxlength="1" 
                        class="otp-box"
                        style="width: 50px; height: 50px; text-align: center; font-size: 20px; font-weight: 600; border: 2px solid #CECECE; border-radius: 8px; background: #FFFFFF;"
                        (keyup)="onOtpKeyUp($event, 2, otp3)"
                        [(ngModel)]="otpDigits[1]"
                        [ngModelOptions]="{standalone: true}"/>
                    <input 
                        #otp3
                        type="text" 
                        maxlength="1" 
                        class="otp-box"
                        style="width: 50px; height: 50px; text-align: center; font-size: 20px; font-weight: 600; border: 2px solid #CECECE; border-radius: 8px; background: #FFFFFF;"
                        (keyup)="onOtpKeyUp($event, 3, otp4)"
                        [(ngModel)]="otpDigits[2]"
                        [ngModelOptions]="{standalone: true}"/>
                    <input 
                        #otp4
                        type="text" 
                        maxlength="1" 
                        class="otp-box"
                        style="width: 50px; height: 50px; text-align: center; font-size: 20px; font-weight: 600; border: 2px solid #CECECE; border-radius: 8px; background: #FFFFFF;"
                        (keyup)="onOtpKeyUp($event, 4, otp5)"
                        [(ngModel)]="otpDigits[3]"
                        [ngModelOptions]="{standalone: true}"/>
                    <input 
                        #otp5
                        type="text" 
                        maxlength="1" 
                        class="otp-box"
                        style="width: 50px; height: 50px; text-align: center; font-size: 20px; font-weight: 600; border: 2px solid #CECECE; border-radius: 8px; background: #FFFFFF;"
                        (keyup)="onOtpKeyUp($event, 5, otp6)"
                        [(ngModel)]="otpDigits[4]"
                        [ngModelOptions]="{standalone: true}"/>
                    <input 
                        #otp6
                        type="text" 
                        maxlength="1" 
                        class="otp-box"
                        style="width: 50px; height: 50px; text-align: center; font-size: 20px; font-weight: 600; border: 2px solid #CECECE; border-radius: 8px; background: #FFFFFF;"
                        (keyup)="onOtpKeyUp($event, 6, null)"
                        [(ngModel)]="otpDigits[5]"
                        [ngModelOptions]="{standalone: true}"/>
                </div>
                <div *ngIf="otpSubmitted && otpF['otp'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF['otp'].errors.required">OTP is required</div>
                    <div class="errorStyle" *ngIf="otpF['otp'].errors.pattern">OTP must be 6 digits</div>
                </div>
                
                <!-- Resend OTP Link -->
                <div class="resend-otp" style="margin-top: 10px; text-align: right;">
                    <a href="javascript:void(0);" 
                       style="color: #004D87; font-size: 14px; font-weight: 600; text-decoration: none;"
                       [style.color]="resendDisabled ? '#999999' : '#004D87'"
                       [style.cursor]="resendDisabled ? 'not-allowed' : 'pointer'"
                       [style.pointer-events]="resendDisabled ? 'none' : 'auto'"
                       (click)="resendOTP()">
                        {{ resendDisabled ? 'Resend OTP in ' + resendTimer + 's' : 'Resend OTP' }}
                    </a>
                </div>
            </div>

            <div class="signForm-row signUpT">
                Read our <a href="https://digicoffer.com/digicoffer_terms.pdf">Terms</a> & <a href="https://digicoffer.com/privacy.html">Privacy Policy</a>
            </div>
            
            <div class="signForm-row">
                <button type="button" 
                        class="signBtn" 
                        *ngIf="otpSent"
                        style="background: #EEEEEE; color: #000000; margin-right: 10px;"
                        (click)="cancelRegistration()">
                    Cancel
                </button>
                <button type="submit" 
                        class="signBtn"
                        [disabled]="otpRequestInProgress">
                    {{ otpSent ? 'Verify & Register' : 'Send OTP' }}
                </button>
            </div>
        </form>
        
        <div class="signForm-row termsPolicy">
            Already have an account? <a routerLink="/login">Sign In</a>
        </div>

        <div class="signForm-row" style="text-align:center">© 2020 DigiCoffer Inc</div>
    </div>
</div>